import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../../../common/common.model';

export interface ExtRoleItem {
    tenantId: number;
    roleId: number;
    startDate: Date;
    endDate: Date;
    roleDefaultInitials: string;
    roleDefaultShortName: string;
    roleDefaultName: string;
    clientTranslationTextId: number | null;
    createdByUserId: number;
    createdOn: string;
    lastUpdatedByUserId: number;
    lastUpdatedOn: string;
}

export interface RoleItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
}

class RoleItemModelTransformer
    implements ModelTransformer<RoleItem, ExtRoleItem>
{
    transform(model: ExtRoleItem): RoleItem {
        return {
            id: model.roleId,
            initials: model.roleDefaultInitials,
            shortName: model.roleDefaultShortName,
            name: model.roleDefaultName,
        };
    }
}

export class RoleItemModelSetTransformer extends ModelSetTransformer<
    RoleItem,
    ExtRoleItem
> {
    protected newTransformer(): ModelTransformer<RoleItem, ExtRoleItem> {
        return new RoleItemModelTransformer();
    }
}
